(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function buildDirectory(scope) {
      scope.querySelectorAll('template[data-ms-article-toc]').forEach(template => {
        const body = template.parentElement.querySelector('.hdt-article-content');
        if (!body || body.querySelector('.ms-article-toc')) return;

        const headings = [...body.querySelectorAll('h2')].filter(heading =>
          heading.textContent.trim() && !heading.closest('nav, aside, [hidden]')
        );
        if (headings.length < 2) return;

        const directory = template.content.firstElementChild.cloneNode(true);
        const list = directory.querySelector('ol');
        headings.forEach((heading, index) => {
          const title = heading.textContent.trim();
          if (!heading.id || document.getElementById(heading.id) !== heading) {
            const base = 'section-' + (title.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '') || (index + 1));
            let id = base;
            let suffix = 2;
            while (document.getElementById(id)) id = base + '-' + suffix++;
            heading.id = id;
          }
          heading.classList.add('ms-toc-target');
          const link = document.createElement('a');
          link.setAttribute('href', '#' + encodeURIComponent(heading.id));
          link.textContent = title.replace(/^\s*\d+[.)、．]\s*(?!\d)/u, '').trim() || title;
          const item = document.createElement('li');
          item.append(link);
          list.append(item);
        });
        headings[0].before(directory);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => buildDirectory(document), { once: true });
    } else {
      buildDirectory(document);
    }
    document.addEventListener('shopify:section:load', event => buildDirectory(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
